import { useTranslation } from 'next-i18next';

import styles from './about-principes.module.css';

const AboutPrincipes = ({ items }) => {
  const { t } = useTranslation();

  if (!items) return null;

  return (
    <div className={styles.root}>
      <div className={styles.title}>
        {t('about_principes_title')}
      </div>
      <div className={styles.content}>
        {items.map(({ image, title, description }, index) => (
          <div className={styles.item} key={index}>
            <div className={styles.itemContent}>
              <img className={styles.itemImage} src={image} alt={title} />
              <div className={styles.itemTitle}>{title}</div>
            </div>
            <div className={styles.itemDescription}>{description}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AboutPrincipes;
